'use client';

import styles from './EpIncidentSteps.module.scss';
import { EpCard } from '../../components/EpCard';
import { FormIncidentNotification } from '../../components/HookFormComponents/Forms/IncidentNotification/FormIncidentNotification';
import { Suspense } from 'react';
export const dynamic = 'force-dynamic';

export const IncidentStepsContent = ({
  isPublicTemplate = false,
}: {
  isPublicTemplate?: boolean;
}) => {
  return (
    <Suspense>
      <section className={styles['section']}>
        <div className={styles['card']}>
          <EpCard
            cardId="ep-card-default"
            cardElevation="one"
            cardBodyContentWidthType="contained"
            cardHeaderIconName="solid-cube"
            cardHeight="self"
            cardSpace="xl"
            cardWidth={964}
          >
            <div slot="card-body-content">
              <FormIncidentNotification isPublicTemplate={isPublicTemplate} />
            </div>
          </EpCard>
        </div>
      </section>
    </Suspense>
  );
};
